import { customAlphabet } from "nanoid/non-secure";
import { AxiosResponseHeaders } from "axios";

import { UserData } from "@/types/auth";

const nanoid = customAlphabet("abcdefghijklmnopqrstuvwxyz0123456789");
const identifierKey = "deviceIdentifier";
const identitySize = 26;

export const getDeviceIdentifier = () => {
  const currentID = localStorage.getItem(identifierKey);

  if (!currentID) {
    const id = nanoid(identitySize);

    localStorage.setItem(identifierKey, id);

    return id;
  }

  return currentID;
};

export const saveDataUser = (data: UserData, headers: AxiosResponseHeaders) => {
  const { uid, client, expiry, "access-token": token } = headers;

  localStorage.setItem(
    "auth",
    JSON.stringify({
      uid,
      client,
      expiry,
      "access-token": token,
    }),
  );

  localStorage.setItem(
    "user",
    JSON.stringify({
      ...data,
    }),
  );

  return data;
};
